import {XHTTP} from '@/shared/xhttp';
import {TacheService} from "@/xhttp/TacheService";
import {Projet} from "@/models/Projet";

@XHTTP(TacheService, '/taches')
export class Tache {

	private _id: number;
	private _name: string;
	private _description: string;
	private _cloture: boolean;
	private _projet: Projet;
	private _createdAt: Date;

	/////////////
	// Getters //
	/////////////

	public get id(): number {
		return this._id;
	}

	public get name(): string {
		return this._name;
	}

	public get description(): string {
		return this._description;
	}

	public get cloture(): boolean {
		return this._cloture;
	}

	public get projet(): Projet {
		return this._projet;
	}

	public get createdAt(): Date {
		return this._createdAt;
	}

	/////////////
	// Setters //
	/////////////

	public set name(value: string) {
		this._name = value;
	}

	public set description(value: string) {
		this._description = value;
	}

	public set cloture(value: boolean) {
		this._cloture = value;
	}

	public set projet(value: Projet) {
		this._projet = value;
	}

	///////////////
	// Serialize //
	///////////////+

	public toJSON(): any {
		return {
			id       : this._id,
			name     : this._name,
			description     : this._description,
			cloture  : this._cloture,
			projet  : this._projet ? this._projet.id : null,
		};
	}

	public fromJSON(data: any): this {
		this._id        = data.id;
		this._name      = data.name;
		this._description      = data.description;
		this._cloture   = data.cloture;
		this._projet    = data.projet ? (new Projet()).fromJSON(data.projet) : null;
		this._createdAt                  = data.createdAt ? new Date(data.createdAt) : null;
		return this;
	}
}